import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]

import {  ref, Ref, computed } from 'vue'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber, getNumber } from '@/utils/index'

import dayjs from 'dayjs'

import Api from '@/http/modules'

export default /*#__PURE__*/_defineComponent({
  setup(__props: any) {

const props = __props as {}

let { 
  'POST/house_lease_costs/org': fetchList
 } = Api


const { 
  MI_tableData, fetchData, page, size,
  MI_total, MI_pageChange, MI_sizeChange,
  MI_identify, MI_params, MI_modifyForm, MI_height, 
} = new tbMix(fetchList)

const searchConfig = ref([
  {
    type: "TIME",
    label: "日期",
    value: dayjs().subtract(1, 'month').format('YYYY-MM') + '-01',
    upKey: 'date',
    props: {
      type: 'month',
      'value-format': 'YYYY-MM-DD'
    }
  },
])
let repTotalData: any = ref([])
const searchHandle = async (params: object) => {
  let repData = await fetchData(params, {}, 1);
  ['合计', '当前月未分配', '总计'].map((str: string, index: number) =>{
    repData.total[index].orgName = str
  })
  repTotalData.value = MI_tableData.value.concat(repData.total)
}


return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "成本查询" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
            initSearch: true,
            title: true,
            searchConfig: searchConfig.value,
          }, { onSearchFn: searchHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(repTotalData),
      "max-height": _unref(MI_height) + 60 + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "团队名称",
          prop: "orgName"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", {
              class: "pointer",
              onClick: ($event: any) => (_ctx.$router.push({ name: 'leaseTeamCost', params: {orgId: row.orgId, orgName: row.orgName }}))
            }, _toDisplayString(row.orgName), 9, _hoisted_1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "在职人数",
          prop: "peopleQuantity",
          align: "right"
        }),
        _createVNode(_component_el_table_column, {
          label: "房租",
          prop: "rentFee",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "物管费",
          prop: "pmFee",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "水电费",
          prop: "utilitiesFee",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "其他费用",
          prop: "otherFee",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "未分配费用",
          prop: "unassignedFee",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "电脑费用",
          prop: "computerFee",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "总计",
          prop: "total",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"])
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ])
  ]))
}
}

})